import {
  Box,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useEffect, useState } from 'react';
import RadioButtonLabel from './radioButtonLabel';
import { upgradeSubscriptionEventPayload } from './helpers/upgradeSubscriptionHelper';

const useStyles = makeStyles((theme) => ({
  headerLabel: {
    fontFamily: 'Formula1-Bold',
    fontWeight: 700,
    fontSize: '18px',
    [theme.breakpoints.between('xs', 'md')]: {
      lineHeight: 1.43,
    },
  },
  radio: {
    '&.Mui-checked': {
      color: '#ffffff',
    },
  },
  priceDetailsContainerSelected: {
    width: '100%',
    [theme.breakpoints.between('xs', 'md')]: {
      flexDirection: 'column',
    },
  },
  priceDetailsContainer: {
    width: '100%',
    [theme.breakpoints.between('xs', 'md')]: {
      flexDirection: 'column',
    },
  },
  formControlLabel: {
    width: '100%',
    margin: 0,
    '& .MuiFormControlLabel-label': {
      width: '100%',
    },
  },
  radioGroupClass: {
    [theme.breakpoints.between('xs', 'md')]: {
      flexWrap: 'nowrap',
    },
  },
}));

const PlanDetails = ({
  toggleBillCycleEligibleList,
  setSelectedEligiblePlan,
  language,
}) => {
  const classes = useStyles();

  const [selectedEligiblePlanId, setSelectedEligiblePlanId] = useState(
    toggleBillCycleEligibleList?.[0].Id,
  );

  const handleOnChange = (event) => {
    const getSelectedEligibleList = toggleBillCycleEligibleList.find(
      (item) => item.Id === event.target.value,
    );
    setSelectedEligiblePlanId(event.target.value);
    setSelectedEligiblePlan(getSelectedEligibleList);
    const getEventPayload = upgradeSubscriptionEventPayload({
      language,
      selectedEligiblePlan: getSelectedEligibleList,
    });
    postMessage('module.subscriptionSelectionChange', getEventPayload);
  };

  useEffect(() => {
    if (toggleBillCycleEligibleList?.length) {
      setSelectedEligiblePlanId(toggleBillCycleEligibleList?.[0].Id);
    }
  }, [toggleBillCycleEligibleList]);

  return (
    <Box display="flex" flexDirection="column" gridRowGap={16}>
      {toggleBillCycleEligibleList?.map((item) => (
        <Box display="flex" key={item.Id}>
          <FormControl fullWidth>
            <RadioGroup
              aria-labelledby="radio-buttons-group-label"
              name="radio-buttons-group"
              onChange={handleOnChange}
              value={selectedEligiblePlanId}
              className={classes.radioGroupClass}
            >
              <Box
                py={1}
                px={1}
                display="flex"
                justifyContent="space-between"
                sx={{
                  borderRadius:
                    selectedEligiblePlanId === item.Id ? '12px' : '12px',
                  bgcolor:
                    selectedEligiblePlanId === item.Id ? '#000000' : '#ffffff',
                  color:
                    selectedEligiblePlanId === item.Id ? '#ffffff' : 'unset',
                  border:
                    selectedEligiblePlanId === item.Id
                      ? '2px solid #E6F854'
                      : 'unset',
                }}
              >
                <Box
                  display="flex"
                  justifyContent="space-between"
                  py={3}
                  px={3}
                  className={classes.priceDetailsContainer}
                >
                  <Box width="100%">
                    <FormControlLabel
                      value={item.Id}
                      className={classes.formControlLabel}
                      control={
                        <Radio
                          style={{
                            display:
                              toggleBillCycleEligibleList.length <= 1
                                ? 'none'
                                : 'block',
                          }}
                          disableRipple
                          className={classes.radio}
                        />
                      }
                      label={
                        <RadioButtonLabel
                          item={item}
                          selectedEligiblePlanId={selectedEligiblePlanId}
                        />
                      }
                    />
                  </Box>
                </Box>
              </Box>
            </RadioGroup>
          </FormControl>
        </Box>
      ))}
    </Box>
  );
};

export default PlanDetails;
